// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------

import { isEnglishLang, isIphone } from '../utils';

export const useGraphic = () => {
  const getLocalizedGraphic = (image: string): string => {
    if (isIphone()) {
      return isEnglishLang() ? `${image}-en.webp` : `${image}-non-en.webp`;
    }

    return isEnglishLang() ? `${image}-ipad-en.webp` : `${image}-ipad-non-en.webp`;
  };

  return {
    getLocalizedGraphic,
  };
};
